export default function() {
  // Convert arguments object to an array and remove the last item (options hash)
  const args = Array.prototype.slice.call(arguments, 0, -1);

  // Return true if every argument is truthy
  return args.every(Boolean);
}
